import { ID, LifeArea } from '@griply/types';

import { isActiveLifeArea } from './is-active-life-area';
import { sortItems } from './sort-items';

export type GetLifeAreaFilterOptionsOptions = {
  lifeAreaSorting?: ID[] | null;
};

export const getLifeAreaFilterOptions = <
  T extends Pick<LifeArea, 'id' | 'archivedAt' | 'frozenAt'>,
>(
  lifeAreas: T[],
  { lifeAreaSorting }: GetLifeAreaFilterOptionsOptions,
): T[] => sortItems(lifeAreas.filter(isActiveLifeArea), lifeAreaSorting, 'id');
